import { z } from 'zod';
/**
 * Área solicitante: quién pide el requerimiento o la orden. Mismo caso que
 * `obras` —dato maestro compartido que sale como columna en dos reportes— y
 * mismo problema hasta ahora: solo se cargaba por semilla.
 *
 * `areas.nombre_zh` existe en la base y conserva sus datos, pero este módulo NO
 * lo toca: no se lee, no se escribe y no se muestra. Quien lo siga usando es
 * `/catalogos`, que lo devolvía desde antes.
 */
export const areaEntrada = z.object({
    // Convención del área (IISS, EQUIP_MED), no un correlativo. En mayúsculas
    // porque así están las doce que ya existen.
    codigo: z.string().trim().min(2, 'El código es obligatorio').max(30)
        .transform((v) => v.toUpperCase()),
    nombre: z.string().trim().min(2, 'El nombre del área es obligatorio').max(80),
    activo: z.boolean().default(true),
});
/**
 * `.partial()` hace opcionales los campos pero NO elimina sus `.default()`: sin
 * volver a declarar `activo`, editar el nombre reactivaría un área dada de baja.
 * Mismo defecto corregido en `empresaEdicion` y `obraEdicion`.
 */
export const areaEdicion = areaEntrada.partial().extend({
    activo: z.boolean().optional(),
});
export const area = z.object({
    id: z.number().int(),
    codigo: z.string(),
    nombre: z.string(),
    activo: z.boolean(),
});
export const idArea = z.object({
    id: z.coerce.number().int().positive(),
});
//# sourceMappingURL=area.js.map